import { render, staticRenderFns } from "./RisksAnalysisActive.vue?vue&type=template&id=5ad479a5&scoped=true"
import script from "./RisksAnalysisActive.vue?vue&type=script&lang=js"
export * from "./RisksAnalysisActive.vue?vue&type=script&lang=js"
import style0 from "./RisksAnalysisActive.vue?vue&type=style&index=0&id=5ad479a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad479a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VRow,VToolbar,VToolbarTitle})
